import React from 'react';
import { Sidebar } from './components/Sidebar';
import { ChatArea } from './components/ChatArea';
import { CheckpointNavigator } from './components/CheckpointNavigator';
export function App() {
  return <div className="flex h-screen w-full bg-white overflow-hidden font-sans text-[#1e1e1e]" data-id="element-0">
      <Sidebar data-id="element-1" />
      <ChatArea data-id="element-2" />
      <CheckpointNavigator data-id="element-3" />
    </div>;
}